import React, { useEffect, useRef } from 'react';
import { preloadImages, debounce } from '../utils/utils';

const CanvasRenderer = ({ imageGroup, index, title, stageWidth, stageHeight, imageMeasureUnit, marginCheck, marginValue }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const createCanvas = async () => {
      const container = containerRef.current;
      const canvas = canvasRef.current;
      if (!canvas || !container) return;

      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      const imageArray = Object.values(imageGroup).filter(
        item => typeof item === 'object' && item.path
      );
      let loadedImages = await preloadImages(imageArray);

      const scaleWidth = containerWidth / stageWidth;
      const scaleHeight = containerHeight / stageHeight;
      const scale = Math.min(scaleWidth, scaleHeight, 1);

      canvas.width = Math.floor(stageWidth * scale);
      canvas.height = Math.floor(stageHeight * scale);
      canvas.style.maxWidth = '100%';
      canvas.style.maxHeight = '100%';
      canvas.style.display = 'block';
      canvas.style.margin = '0 auto';
      canvas.style.border = '2px solid #FF5733';

      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#E8F4FC';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);

      let margin;
      if (imageMeasureUnit === 'in' && marginCheck) {
        margin = marginValue * 300;
      } else if (imageMeasureUnit === 'cm' && marginCheck) {
        margin = (marginValue * 300) / 2.54;
      } else {
        margin = 0;
      }

      loadedImages.forEach(({ img, item }) => {
        if (item.rotated) {
          const imgWidth = item.height - margin;
          const imgHeight = item.width - margin;
          ctx.save();
          ctx.translate(item.x, item.y);
          ctx.rotate(Math.PI / 2);
          ctx.drawImage(img, 0, -imgHeight, imgWidth, imgHeight);
          ctx.restore();
        } else {
          const w = item.width - margin;
          const h = item.height - margin;
          ctx.drawImage(img, item.x, item.y, w, h);
        }
      });
    };

    createCanvas();
    const handleResize = debounce(() => createCanvas(), 250);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [imageGroup, stageWidth, stageHeight, imageMeasureUnit, marginCheck, marginValue]);

  return (
    <div className="apply-cardcontent">
      <div
        className="apply-imgDiv"
        ref={containerRef}
        style={{
          height: "248px",
          width: "100%",
          position: "relative",
          backgroundColor: "rgb(215 215 212)",
          border: "1px dashed #3498DB",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px"
        }}
      >
        <canvas ref={canvasRef}></canvas>
      </div>
    </div>
  );
};

export default CanvasRenderer;
